import {
    Button, Container
} from "@material-ui/core";
import { DataGrid, deDE, GridCellParams, GridColDef, GridValueGetterParams, LocalizationV4 } from '@material-ui/data-grid';
import {
    Delete
} from "@material-ui/icons";
import PropTypes from "prop-types";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { globalStyles } from "../../assets/globalStyles";
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { gespeicherteSuche } from "../../utils/apiTypes";
import { toUTCDateString } from '../../utils/utils';
import { messgroesse } from './../../utils/apiTypes';
import { deleteGespeicherteSuche, emptyTab, loadGespeicherteSuche, selectGespeicherteSuchen, selectSucheLoading } from "./netzwirtschaftSlice";
import { useStyles } from "./netzwirtschaftStyles";




export interface NetzwirtschaftSavedSearchGridProps {
    setOpenSavedSearchesDialog: (newValue: boolean) => void;
}



export const NetzwirtschaftSavedSearchGrid = ({ setOpenSavedSearchesDialog }: NetzwirtschaftSavedSearchGridProps): JSX.Element => {
    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const sucheLoading: boolean = useAppSelector(selectSucheLoading);
    const isUTC = useAppSelector(selectDate);
    const gespeicherteSuchen: gespeicherteSuche[] = useAppSelector(selectGespeicherteSuchen);


    const savedSearchTableCols: GridColDef[] = [
        { field: 'name', headerName: 'Name', flex: 0.6 },
        { field: 'uw', headerName: 'Umspannwerk', flex: 0.7, valueGetter: (params: GridValueGetterParams) => params.row.wert.fields.uw },
        { field: 'messpunkt', headerName: 'Messpunkt', flex: 0.7, valueGetter: (params: GridValueGetterParams) => params.row.wert.fields.messpunkt },
        { field: 'rekorder', headerName: 'Rekorder', flex: 0.7, valueGetter: (params: GridValueGetterParams) => params.row.wert.fields.rekorder.beschreibung + " - " + params.row.wert.fields.rekorder.kategorie },
        {
            field: 'messgroesse', headerName: 'Messgrößen', flex: 1, sortable: false, renderCell:
                function messgroessen(params: GridValueGetterParams) { const t = params.row.wert.fields.messgroesse.map((x: messgroesse) => x.beschreibung + " (" + x.feldname + ")").join(", "); return <span title={t}>{t}</span>; }
        },
        { field: 'start', headerName: 'Startzeitpunkt', filterable: false, flex: 0.6, valueGetter: (params: GridValueGetterParams) => (isUTC ? toUTCDateString(new Date(params.row.wert.fields.startDatum)) : new Date(params.row.wert.fields.startDatum).toLocaleString()) },
        { field: 'ende', headerName: 'Endzeitpunkt', filterable: false, flex: 0.6, valueGetter: (params: GridValueGetterParams) => (isUTC ? toUTCDateString(new Date(params.row.wert.fields.endDatum)) : new Date(params.row.wert.fields.endDatum).toLocaleString()) },
        {
            field: 'delete', headerName: 'Aktion', flex: 0.3, sortable: false, renderCell: function actions(params: GridCellParams) {
                return <Button disabled={!params.row.istLoeschbar} onClick={() => dispatch(deleteGespeicherteSuche(params.row as gespeicherteSuche))}><Delete /></Button>
            }, filterable: false
        }
    ]


    return (
        <Container maxWidth={false} className={classes.root}>
            <div style={{ height: "50vh", width: '70vw' }}>
                <DataGrid
                    localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                    columns={savedSearchTableCols}
                    rows={gespeicherteSuchen}
                    loading={sucheLoading}
                    disableColumnSelector={true}
                    sortModel={[
                        {
                            field: 'name',
                            sort: 'asc',
                        },
                    ]} onCellClick={(param: GridCellParams) => {
                        if (param.field == "delete") return false;
                        let tabData = emptyTab(1);
                        const temp = gespeicherteSuchen.find(x => x.id == (param.row.id as number));
                        if (temp)
                            tabData = temp.wert;
                        dispatch(loadGespeicherteSuche(tabData));
                        setOpenSavedSearchesDialog(false);
                    }} />
            </div>
        </Container>
    );
}
NetzwirtschaftSavedSearchGrid.propTypes = {
    setOpenSavedSearchesDialog: PropTypes.func.isRequired
};
